import {useEffect,useState} from 'react';
import {useParams} from 'react-router-dom';
import './GeneratePasses.css';
import { Link } from 'react-router-dom';
import { ORDER_BASE_URL } from '../../../../config/ApiConfig';
import axios from 'axios';
import html2pdf from 'html2pdf.js';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
export const GeneratePasses = ()=>{
    const { OrderGUID } = useParams();
    const [orderNumber,setOrderNumber]= useState(0);
    const [orderDate,setOrderDate]=useState('');
    const [email,setEmail]= useState('');
    const [passItem,setPassItem]=useState([]);
    const [shippingData,setShippingData]=useState({});
    const [billingData,setBillingData]=useState({});
    const [errorMessage,setErrorMessage]=useState('');

    useEffect(()=>{
        setErrorMessage('');
        if(OrderGUID){
            getOrderDetails();
        }
    },[OrderGUID]);

    useEffect(() => {
        // Select the nav element
        const navElement = document.querySelector('nav');
        if (navElement) {
            navElement.style.display = 'none';
        }
        // Create a Google Analytic script element
        const gaScript = document.createElement('script');
        gaScript.type = 'text/javascript';
        gaScript.innerHTML = `
          gtag('event', 'conversion', {
            'send_to': 'AW-962876782/szZ0CPi9jXgQ7qqRywM',
            'value': 1.0,
            'currency': 'USD',
            'transaction_id': ''
        });
        `;
        //Facebook Pixel Code----
        const fbScript = document.createElement('script');
        fbScript.type = 'text/javascript';
        fbScript.src = '/scripts/pages/fb-ad-coversion-tracking.js';

        const fbNoscript = document.createElement('noscript');
        fbNoscript.innerHTML = `
        <img height="1" width="1" style="display:none"
            src="https://www.facebook.com/tr?id=587760308037267&ev=PageView&noscript=1" />
        `;
        //End Facebook Pixel Code---
        // Append scripts to the document head
        document.head.appendChild(gaScript);
        document.head.appendChild(fbScript);
        document.body.appendChild(fbNoscript);
        return () => {
            if (navElement) {
                navElement.style.display = 'flex';
            }
            document.head.removeChild(gaScript);
            document.head.removeChild(fbScript);
            document.body.removeChild(fbNoscript);
        };
    }, []);
    const  getOrderDetails=async()=>{
        try{
            const response = await axios.get(`${ORDER_BASE_URL}/GetOrderDetailsByGUID/${OrderGUID}`);
            const {orderGUID,orderDate,passes,billingDetails,shippingDetails} = response.data.data.orderDetails;
            const {emailID}= response.data.data.orderDetails.userDetails;
            setOrderNumber(orderGUID);
            const orddate = orderDate;
            setOrderDate(formatDate(orddate));
            setEmail(emailID);
            setPassItem(passes);
            setShippingData(shippingDetails);
            setBillingData(billingDetails);
        }catch(error){
            console.log(error);
            setErrorMessage(`We couldn't retrieve the Order Details at the moment. We apologize for the inconvenience. Please refresh the page or try again later.`);
        }
    };
    const formatDate = (isoDateString) => {
        const date = new Date(isoDateString);
        const dayName = new Intl.DateTimeFormat('en-US', { weekday: 'long' }).format(date); 
        const monthName = new Intl.DateTimeFormat('en-US', { month: 'long' }).format(date);
        const day = date.getDate();
        const year = date.getFullYear();
        return `${dayName}, ${monthName} ${day}, ${year}`;
    };
    const formatDateShort = (isoDateString) => {
        const date = new Date(isoDateString);
        const monthName = new Intl.DateTimeFormat('en-US', { month: 'long' }).format(date); 
        const day = String(date.getDate()).padStart(2, '0'); 
        const year = date.getFullYear();
        return `${monthName} ${day}, ${year}`;
    };
    const calculateBusinessDays = (isoDateString, businessDaysToAdd) => {
        const date = new Date(isoDateString);
        let addedDays = 0;
        while (addedDays < businessDaysToAdd) {
            date.setDate(date.getDate() + 1); 
            const dayOfWeek = date.getDay(); 
            if (dayOfWeek !== 0 && dayOfWeek !== 6) {
                addedDays++;
            }
        }
        return date;
    };
    // Group items by passID for dynamic handling
    const passGroups = passItem.reduce((groups, item) => {
        const passID = item.passID;
        if (!groups[passID]) {
            groups[passID] = [];
        }
        groups[passID].push(item);
        return groups;
    }, {});
    // Calculate totals dynamically
    const orderSummary = Object.keys(passGroups).map(passID => {
        const items = passGroups[passID];
        const pass = passItem.find(item => item.passID === Number(passID));
        // Check if it’s a One Day Pass or Annual Pass
        if (pass.passID === 1) { // Annual Pass
            // For Annual Pass, group the items 
            const quantity = items.reduce((sum, item) => sum + item.quantity, 0);
            const totalPrice = items.reduce((sum, item) => sum + (item.perUnitPrice + item.processingFee) * item.quantity, 0);      
            return {
                passID: Number(passID),
                quantity,
                totalPrice,
                passName: 'Annual Discover Pass',
                orderItemID: pass.orderItemID,
                passDate:pass.passDate,
                isExpired:(()=>{
                    const expiry = calculateBusinessDays(orderDate,15);
                    const currentDate = new Date();
                    currentDate.setHours(0, 0, 0, 0);
                    return currentDate>expiry;
                })()
            };
        } else { // One Day Pass
            // For One Day Pass, display each pass individually
            return items.map(item => ({
                passID: Number(passID),
                quantity: item.quantity, // Each item is shown individually, so quantity is 1 for each pass
                totalPrice: (item.perUnitPrice + item.processingFee) * item.quantity,
                passName: 'One-Day Discover Pass',
                passDate: item.passDate, // Include the date for the one day pass
                orderItemID: item.orderItemID,
                isExpired: (() => {
                    const passDateString = item.passDate; // Use the passDate from the item
                    const passDate = new Date(passDateString); // Convert to a Date object
                    const currentDate = new Date(); // Get the current date and time
                    currentDate.setHours(0, 0, 0, 0);
                    return currentDate > passDate;
                })()
                
            }));
        }
    }).flat(); // Flatten the array in case of one day passes to avoid nested arrays   
    //Grand total calculation
    const grandTotal = orderSummary.reduce((sum, item) => sum + item.totalPrice, 0);
    const totalProcessingFee = passItem.reduce((total, item) => total + item.processingFee * item.quantity, 0);
    const downloadPdf = async (OrderGUID, passID, OrderItemID) => {
        try {    
            const response = await axios.get(`${ORDER_BASE_URL}/GeneratePass?orderGUID=${OrderGUID}&passTypeID=${passID}&orderItemID=${OrderItemID}`);
            if (response.data && response.data.data && response.data.data.length > 0) {
                const htmlContents = response.data.data;
                // Create a PDF container to hold multiple pages
                const pdfContainer = document.createElement('div');
                let firstPage = true;
                // Loop through each HTML content and append it to the PDF document
                for (let i = 0; i < htmlContents.length; i++) {
                    const htmlContent = htmlContents[i].htmlContent; 
                    // Create a temporary container for the current HTML content
                    const pageContainer = document.createElement('div');                  
                    // Extract only the body content (strip out <html>, <head>, <body> tags)
                    const doc = new DOMParser().parseFromString(htmlContent, 'text/html');
                    const bodyContent = doc.body; // Get the content within the <body> tag                    
                    // Append the body content to the pageContainer
                    pageContainer.innerHTML = bodyContent.innerHTML;       
                    // If it's not the first page, add a page break
                    if (!firstPage) {
                        const pageBreak = document.createElement('div');
                        pageBreak.style.pageBreakBefore = 'always'; // This ensures a page break between items
                        pdfContainer.appendChild(pageBreak);
                    } else {
                        firstPage = false; // Set firstPage flag to false after the first page
                    }   
                    // Append the current page's content to the PDF container
                    pdfContainer.appendChild(pageContainer);
                }    
                // Get the current date and time formatted as MM_DD_YYYY_HH_MM_SS
                const now = new Date();
                const formattedDate = `${now.getMonth() + 1}_${now.getDate()}_${now.getFullYear()}_${now.getHours()}_${now.getMinutes()}_${now.getSeconds()}`; 
                // Generate the dynamic filename
                const passTypeName = response.data.data[0].passTypeName.replace(/\s+/g, '_'); // Replace spaces with underscores
                const dynamicFilename = `${passTypeName}_${OrderGUID}_${formattedDate}.pdf`;
                // Configure the options for the PDF generation
                const options = {
                    filename: dynamicFilename,   // Set the dynamic filename
                    html2canvas: { scale: 2 },        // Optional: Increase the resolution of the generated PDF
                    jsPDF: {
                        unit: 'mm',
                        format: 'a4',
                        orientation: 'portrait',    // Customize the PDF format
                        compress: true              // Optional: Compress the output
                    },
                };
                // Use html2pdf to convert the content to a PDF with multiple pages
                html2pdf().from(pdfContainer).set(options).save();  // Trigger the PDF download
            }
        } catch (error) {
            console.error("Error while downloading PDF:", error);
        }
    };
    const printReciept = async () => {
        try {
            const response = await axios.get(`${ORDER_BASE_URL}/GenerateInvoice/?orderGUID=${OrderGUID}`);
            const responseHtml = response.data.data;
            // Create an invisible iframe element dynamically
            const iframe = document.createElement('iframe');
            iframe.style.position = 'absolute';
            iframe.style.width = '0';
            iframe.style.height = '0';
            iframe.style.border = 'none';
            // Append the iframe to the body (it will be hidden)
            document.body.appendChild(iframe);
            // Write the HTML content into the iframe's document dynamically
            const iframeDocument = iframe.contentWindow.document;
            iframeDocument.open();
            iframeDocument.write(responseHtml);
            iframeDocument.close();
            // Wait for the iframe's content to load and then trigger print
            iframe.onload = () => {
                iframe.contentWindow.print();  // Trigger the print dialog from the iframe
                // Remove the iframe after printing to clean up the DOM
                document.body.removeChild(iframe);
            };
        } catch (error) {
            console.log("While Printing Receipt got error-", error);
        }
    };
    if (errorMessage) {
        return <div className="errorHandling"><h2 className="errorHandles">{errorMessage}</h2></div>;
    }
    return(
        <>
        <div className="passes-container my-5">
            <div className="orderPass">
                {orderSummary.length === 0?<>
                    <div className="skeleton-wrapper d-flex flex-column">
                        <Skeleton height={30} width="100px" />
                        <Skeleton height={15} width="60%" />
                        <Skeleton height={15} width="50%" />
                        <Skeleton height={100} width="100%" />
                        <Skeleton height={30} width="40%" />
                        <Skeleton count={5} width="80%" />
                    </div>
                </>:<>
                    <h2 className='greet'>Thank you!</h2>
                    <p className='ord'><strong>Order Number: {orderNumber} </strong></p>
                    {orderDate && <>
                        <p className='ord' style={{marginTop:"0px"}}><strong>Order Date: {orderDate}</strong></p>
                    </>}
                    <p className='hide-print'>
                        A confirmation email is on its way to you <strong>{email}</strong>, which contains a link to this page so you can view and print your passes when you are ready. 
                        If you are unable to print, write the transaction number and date from your printable PDF pass on a piece of paper in large bold print and display it on your car's dashboard.
                    </p>
                    <div className="passes-wrap d-flex justify-content-between">
                        <div className="print-pass-section">
                            <div className="passes-head">Print Your Pass (PDF)</div>
                            {orderSummary && orderSummary.map((item, index) => {
                                const isExpired = item.isExpired; 
                                return isExpired ? (
                                    // Render a disabled pass
                                    <span  key={index}  className="pass-link disabled"  title="This pass is expired and cannot be downloaded."  style={{textDecoration: 'line-through' }}>
                                        {item.passName === 'Annual Discover Pass' ? (
                                            <>
                                                TEMPORARY Annual Discover Pass ({item.quantity}) 
                                                <span className="expires">{`(Expires ${formatDateShort(calculateBusinessDays(orderDate, 15))})`}</span>
                                            </>
                                        ) : (
                                            <>
                                                {item.passName} ({item.quantity}) : 
                                                {item.passDate && (
                                                    <span className="pass-date">
                                                        {new Date(item.passDate).toLocaleDateString('en-US', {
                                                            weekday: 'long',
                                                            month: 'long',
                                                            day: 'numeric',
                                                            year: 'numeric',
                                                        })}
                                                    </span>
                                                )}
                                            </>
                                        )}
                                    </span>
                                ) : (
                                    // Render an active pass link
                                    <Link key={index} className="pass-link" onClick={() => downloadPdf(OrderGUID,item.passID,item.orderItemID )}>
                                    {item.passName === 'Annual Discover Pass' ? (
                                        <>
                                            TEMPORARY Annual Discover Pass ({item.quantity}) 
                                            <span className="expires">{`(Expires ${formatDateShort(calculateBusinessDays(orderDate, 15))})`}</span>
                                        </>
                                    ) : (
                                        <>
                                            {item.passName} ({item.quantity}) : 
                                            {item.passDate && (
                                                <span className="pass-date">
                                                    {` ${new Date(item.passDate).toLocaleDateString('en-US', {
                                                        weekday: 'long',
                                                        month: 'long',
                                                        day: 'numeric',
                                                        year: 'numeric',
                                                    })}`}
                                                </span>
                                            )}
                                        </>
                                    )}
                                    </Link>
                                );
                            })}
                        </div>
                        <div className="passes-more">
                            <div className="passes-more-box">
                                <Link to="https://public.govdelivery.com/accounts/WAPARKS/subscriber/new" target="_blank">Stay connected</Link>
                                Sign up for updates from your Washington state recreation lands
                            </div>
                            <div className="passes-more-box">
                                <Link to="http://www.discoverpass.wa.gov/143//Washington-Recreation-Lands" target="_blank">Where can I use my pass?</Link>
                                Explore Washington state recreation lands
                            </div>
                            <div className="passes-more-box">
                                <Link to="https://fishhunt.dfw.wa.gov" target="_blank">Need a fishing or hunting license?</Link>
                                Purchase your license today
                            </div>
                            <div className="passes-more-box">
                                <Link to="http://www.discoverpass.wa.gov/143//Washington-Recreation-Lands" target="_blank">Support your public lands</Link>
                                Make a donation to Washington state recreation lands
                            </div>
                        </div>
                    </div>
                    <Link to="#" className="printwindow" onClick={() => printReciept(OrderGUID)}><span>Print Your Receipt</span></Link>
                    <h2 className='orderHeading'>Your Order Details</h2>
                    <div className="review-cols d-flex justify-content-between">
                        <div className="review-wrap d-flex justify-content-between">
                            <div className="review-col">
                                <div className='review-data'>
                                    {passItem && (() => {
                                        const hasAnnualPass = passItem.some(item => item.passID === 1);
                                        const hasOneDayPass = passItem.some(item => item.passID !== 1);
                                        const calculatedDate = calculateBusinessDays(orderDate, 15); // Add 15 business days
                                        return (
                                            <>
                                                {hasAnnualPass && (
                                                    <div>
                                                        <h2>Annual Discover Pass</h2>
                                                        <p>
                                                        Your annual Discover Pass will be sent to you via USPS First Class Mail within 7 to 14 business days.<br/>Your pass will be set to expire 15 business days after the purchase date. You can download and print your temporary pass for immediate use.
                                                        </p>
                                                    </div>
                                                )}
                                                {hasOneDayPass && (
                                                    <div>
                                                        <h2>One-Day Discover Pass</h2>
                                                        <p>Your one-day Discover Passes are available above..</p>
                                                    </div>
                                                )}
                                            </>
                                        );
                                    })()}
                                </div>
                                <div className='review-data'>
                                    {
                                        email && <>
                                            <h2>A link to this page was emailed to:</h2>
                                            <p className="email">{email}</p>
                                        </>
                                    }
                                </div>
                            </div>
                            <div className="review-col review-data">
                                {
                                    shippingData &&<>
                                        <h2>Shipping Address </h2>
                                        <p>{shippingData.shippingFirstName} {shippingData.shippingLastName},<br/>
                                            {shippingData.shippingAddress1},<br/>
                                            {shippingData.shippingAddress2 && <>{shippingData.shippingAddress2},<br/></>}
                                            {shippingData.shippingCity}, {shippingData.shippingState},{shippingData.shippingZip}<br/>
                                            {shippingData.shippingCountry}<br/>
                                        </p>
                                    </>
                                }
                                {                   
                                    billingData && <>
                                        <h2>Billing Address</h2>
                                        <p>{billingData.billingFirstName} {billingData.billingLastName},<br/>
                                            {billingData.billingAddress1},<br/>
                                            {billingData.billingAddress2 && <>{billingData.billingAddress2},<br/></>}
                                            {billingData.billingCity}, {billingData.billingState},{billingData.billingZip}<br/>
                                            {billingData.billingCountry}<br/>
                                        </p>
                                    </>                          
                                }
                            </div>
                        </div>
                        <div className="review-col review-data review-col-order" style={{width: "33%"}}>
                            <h2>Order Total</h2>
                            <div className="review-order">
                                {orderSummary && orderSummary.map((item) => (
                                    <div key={item.passID + (item.passDate || '')} className="order-items">
                                        <div className="order-item-product">
                                            {item.passName} {` (${item.quantity})`} 
                                            {item.passDate && (
                                                <div className="order-item-date">
                                                    {`( ${new Date(item.passDate).toLocaleDateString('en-US', {
                                                        weekday: 'long',
                                                        month: 'long', 
                                                        day: 'numeric', 
                                                        year: 'numeric'
                                                    })} )`}
                                                </div>
                                            )}
                                        </div>
                                        <div className="order-item-subtotal">${item.totalPrice.toFixed(2)}</div>
                                    </div>
                                ))}
                                <div className="review-order-total">
                                    <strong>Order Total: ${grandTotal.toFixed(2)}</strong><br/>
                                    Total processing fee of ${totalProcessingFee.toFixed(2)} included
                                </div>
                            </div>
                        </div>
                    </div>
                </>}
            </div>
        </div>
        </>
    )
}